export default {

	data() {
		return {
			selectedPolygons: [],
		}
	},

	methods: {

        /**
        * Unmarking a polygon
        *   
        */
		deselectPolygon(id) {
			this.selectedPolygons = _.remove(this.selectedPolygons, layer => {
				return layer.feature.properties.id != id;
			});
		},

        /**
        *   Returns the default polygon styling
        */
		getDefaultPolygonStyle(customStyling) {
			let style = {
				color: "black",
				weight: 1.5,
				opacity: 0.7,
				fillOpacity: 0,
				fillColor: "#497ef2"
			}

			if(customStyling && customStyling.default) {
				Object.keys(customStyling.default).forEach(key => {
					style[key] = customStyling.default[key]
				})
			}

			return style
		},

        /**
        *   Returns the clicked polygon styling
        */
		getClickedPolygonStyle(customStyling) {
			let style = {
				color: "red",
				weight: 3,
				opacity: 1,
				fillOpacity: 0,
				fillColor: "#497ef2"
			}

			if(customStyling && customStyling.clicked) {
				Object.keys(customStyling.clicked).forEach(key => {
					style[key] = customStyling.clicked[key]
				})
			}

			return style
		},

        /**
        *   If a polygon is selected we will set the color accordingly
        *   All selected polygons are stored in this.selectedPolygons
        */
		userSelectedAPolygon(clickedLayer, panTo = true, customStyling) {
			// Ingen polygon är vald
			if (this.selectedPolygons.length > 0) {

				// Hitta ifall polygonens id finns i selectedPolygons
				let exists = _.find(this.selectedPolygons, layer => {
					return layer.feature.properties.id == clickedLayer.feature.properties.id;
				})

				// Ifall polygonens id inte är markerad - lägg till polygonen i selectedPolygons + sätt styling
				if (!exists) {
					this.selectedPolygons.push(clickedLayer)
					clickedLayer.setStyle(this.getClickedPolygonStyle(customStyling))

					// Om polygonen redan är markerad - ta bort den ur listan och avmarkera
				} else {
					this.selectedPolygons = _.remove(this.selectedPolygons, layer => {
						clickedLayer.setStyle(this.getDefaultPolygonStyle(customStyling))
						return layer.feature.properties.id != clickedLayer.feature.properties.id;
					});
				}

				// Första polygonen väljs
			} else {
				this.selectedPolygons.push(clickedLayer)
				clickedLayer.setStyle(this.getClickedPolygonStyle(customStyling))
			}

			// When the height of the map updates we need to invalidate the size.
			// Otherwise it will look really wierd.
			// In case we don't use the timout the css event won't have fired
			setTimeout(() => {
				this.map.invalidateSize()
				if (panTo) {
					let center = clickedLayer.getBounds().getCenter()
					if (center) {
						this.map.panTo(center)
					}
				}
			}, 100)

		},

	}

}